import {StatusPageTheme} from "@/lib/types/statuspages.ts";

import {InspireTheme} from "./inspire/InspireTheme.tsx";
import {InspirePlusTheme} from "./inspire_plus/InspirePlusTheme.tsx";
import type {ThemeProps} from "./types.ts";

export const ThemeRenderer = (props: ThemeProps) => {
  switch (props.statusPage.theme) {
    // LEGACY pages render through the Inspire theme so both themes load the same way in the SPA:
    // logo + title header, description, timezone and custom header/footer. INSPIRE_PLUS is the
    // only theme that gets the compact tabbed header.
    case StatusPageTheme.LEGACY:
    case StatusPageTheme.INSPIRE:
      return <InspireTheme {...props} />;
    default:
      return <InspirePlusTheme {...props} />;
  }
};
